<template>
    <div class="comps">
        <List v-if="client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <statsAds v-if="ad" :ad="ad" @emit="emit" />
        <component v-if="component" :is="component" :item="item" :ad="item" @emit="emit" />
        <div v-if="voucher" class="voucher fixed-scroller">
            <div class="v-alert">
                <header><p>Competition</p><div class="x" @click="voucher = false"></div></header>
                <Voucher :voucher="voucher" />
                <div class="btns">
                    <p class="btn del" style="float: left;width: 120px;line-height:2;display: none;">delete</p>
                    <p class="btn" style="float: right;width: 120px;line-height:2">send</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import Voucher from '../components/Voucher.vue';
import WebSoc from '../utils/WebSoc.js';
import statsAds from '../components/statsAds.vue'
import statsComp from '../components/statsComp.vue';
import Alert from '../utils/Alert.js'

export default {
    name: 'members',
    components: {
        List,
        Voucher,
        statsAds,
        statsComp
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    created () {
       
    },
    mounted () {
        var client_id = this.client_id;
        this.list.filter.client_id = client_id;
    },
    data () {
        return {
            voucher: false,
            item: false,
            component: '',
            ad: false,
            list: { 
                t: 'comp-list',
                DB: 'jb-ads',
                dbClient_id: '',
                storeDB: true,
                title: 'Competitions',
                fields: [
                    { title: 'Offer', field: 'title', class: 'td-ulb', width: 300, map: item => item.title || 'no title' },
                    { title: 'Created', field: 'created', class: 'ta-r', width: 200, map: item => item.created > 0 ? format(item.created,'dd/MM/yy HH:mm') : '', type: 'date' },
                    { title: 'Sent', field: 'qtySent', width: 110, class: 'ta-r td-ulb' },
                    { title: 'Tot. Spins', field: 'rotate', class: 'ta-r td-ulb', width: 115 },
                    { title: 'Ind. Spins', field: 'unique', class: 'ta-r td-ulb', width: 115, map: item => Object.keys(item.unique || {}).length },
                    { title: 'Entered', field: 'entries', class: 'ta-r td-ulb', width: 115, map: item => (item.entries || []).length },
                ],
                filter: { client_id: this.client_id, cat: { $regex: 'competition', $options: 'i' } },
                project: { client_id: 1 }
            } 
        }
    },
    methods: {
        'comp-list' ({ field, item, value, e }) {
            console.log('ad-list',field.field);
            switch ( field.field ) {
                case 'title':
                    return this.showVoucher(item);
                case'qtySent':
                case'rotate':
                case 'unique':
                case 'redeemCount':
                case 'dLinkd':
                case 'entries':     
                    return this.showStats(item);  
            }
            console.log('ad-list',{
                e, 
                field,
                item,
                value
            });
        },
        'stats-ads' ({ item, action }) {
            switch ( action ) {
                case 'exit':
                    this.component = '';
                    this.item = false;
            }
        },
        showStats ( item ) {
            WebSoc.SEND('get',{ DB: 'jb-ads', _id: item._id },ad => {
                this.item = ad;
                this.component = 'statsComp';
                
            })
        },
        deleteAd ( voucher ) {
            console.log('deleteAd',JSON.parse(SJON.stringify(voucher)));
        },
        showVoucher ( ad ) {
            WebSoc.SEND('search',{ DB: 'surveys', find: { 'pages.ad_id': ad._id } },campaigns => {
                var campaign = campaigns[0];
                if ( !campaign ) return Alert.yesno('This Ad is in NO Campaigns - Do you want to delete it ?',yes => {
                    if ( !yes ) return;
                    WebSoc.SEND('delete',{ DB: 'jb-ads', _id: ad._id },() => {
                        console.log('deleted',ad);
                    })
                });
                var activity = campaigns.reduce((p,c) => { 
                    
                    var AD = c.pages.find(p => p.ad_id == ad._id); 
                    if ( !AD ) return p; 
                    AD.issued > 0 && ( p.issued += AD.issued ); 
                    AD.redeemed > 0 && ( p.redeemed += AD.redeemed ); 

                    return p;  },{ issued: 0, redeemed: 0 });
                    
                var Ad = campaign.pages.find(p => p.ad_id == ad._id);
                    Ad.issued = activity.issued;
                    Ad.redeemed = activity.redeemed;

                this.voucher = Ad;
            })
        },
        emit ( data ) {
            console.log('Ads.vue emit',data);
            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('what emmit');
        },
    }
}    
</script>